import { render } from "./HandlerIos.vue?vue&type=template&id=de90438c&scoped=true"
import script from "./HandlerIos.vue?vue&type=script&lang=js"
export * from "./HandlerIos.vue?vue&type=script&lang=js"

import "./HandlerIos.vue?vue&type=style&index=0&id=de90438c&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de90438c"]])

export default __exports__